import { useEffect, useState } from "react";
import { useTheme } from "../../../../components/hooks/useTheme";
import { useLocation, useNavigate } from "react-router-dom";
import baseURL from "../../../../configs/api";
import axios from 'axios';
import { Button, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import PleaseWaitPopup from "../../../PleaseWaitPopup";
import CustomFormatDatePicker from "../../../../components/common/CustomFormatDatePicker";
import useGeneral from "../../../../components/hooks/useGeneral";
import Select from "react-select";
import useDelete from "../../../../components/hooks/useDelete";
import colorConfigs from "../../../../configs/colorConfigs";
import useAuth from "../../../../components/hooks/useAuth";
import Cookies from "js-cookie";
import useTenant from "../../../../components/hooks/useTenant";

const accountingAccountOptions: any = [];
for (let i = 1; i <= 8; i++) {
  accountingAccountOptions.push({ value: i, label: i });
}

export const EditSeasons = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const { dateFormat }: any = useGeneral();
  const idNumber = useLocation();
  const { themeStyles } = useTheme();
  const navigate = useNavigate();
  const { setDeletePopup, setData: setDeleteData }: any = useDelete();
  const [name, setName] = useState<string>("");
  const [branchId, setBranchId] = useState<string>("");
  const [dateStart, setDateStart] = useState<string>("");
  const [dateEnd, setDateEnd] = useState<string>("");
  const [minimalRentalPeriodDays, setMinimalRentalPeriodDays] = useState<number>(0);
  const [maxRentalPeriodDays, setMaxRentalPeriodDays] = useState<number>(0);
  const [minimumRentlHours, setMinimumRentlHours] = useState<number>(0);
  const [maximumRentalHours, setMaximumRentalHours] = useState<number>(0);
  const [active, setActive] = useState<string>("Yes");
  const [accountingAccount, setAccountingAccount] = useState<string>("");
  const [branches, setBranches] = useState([]);
  const [disabled, setDisabled] = useState<boolean>(true);
  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

  useEffect(() => {
    axios
      .get(`${baseURL}branch`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setBranches(() =>
          response?.data?.map((item: any) => {
            return { value: item.id, label: item?.branchName };
          })
        );
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setPleaseWaitPopup(true);
    axios
      .get(`${baseURL}season/${idNumber.state}`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setName(response?.data?.name);
        setBranchId(response?.data?.branchId);
        setDateStart((response?.data?.dateStart).split("T")[0]);
        setDateEnd((response?.data?.dateEnd).split("T")[0]);
        setMinimalRentalPeriodDays(response?.data?.minimalRentalPeriodDays);
        setMaxRentalPeriodDays(response?.data?.maxRentalPeriodDays);
        setMinimumRentlHours(response?.data?.minimumRentlHours);
        setMaximumRentalHours(response?.data?.maximumRentalHours);
        setAccountingAccount(response?.data?.accountingAccount);
        setActive(
          response?.data?.isActive ? "Yes" : "No"
        );
        setPleaseWaitPopup(false);
        handleTenantError(null);
      })
      .catch((error) => {
        setPleaseWaitPopup(false);
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idNumber]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    setPleaseWaitPopup(true);
    e.preventDefault();

    await axios
      .put(
        `${baseURL}season?userId=${auth?.id}`,
        JSON.stringify({
          id: idNumber?.state,
          name,
          branchId,
          dateStart,
          dateEnd,
          minimalRentalPeriodDays,
          maxRentalPeriodDays,
          minimumRentlHours,
          maximumRentalHours,
          accountingAccount,
          isActive: active === "Yes"
        }),
        {
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
          },
          withCredentials: true,
        }
      )
      .then(() => {
        setPleaseWaitPopup(false);
        navigate(-1);
        handleTenantError(null);
      })
      .catch((error) => {
        setPleaseWaitPopup(false);
        handleTenantError(error);
      });
  };

  const deleteSeason = () => {
    setDeleteData({
      id: idNumber,
      tilte: `Delete`,
      summary: `Are you sure you want to delete this Season?`,
      isDelete: (callback: any) => {
        fetch(`${baseURL}season?id=${idNumber?.state}&userId=${auth?.id}`, {
          method: 'DELETE',
          headers: {
            'X-Tenant-ID': tenantId,
          }
        })
          .then(() => {
            setPleaseWaitPopup(false);
            navigate(-1);
            callback();
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWaitPopup(false);
            handleTenantError(error);
          });
      }
    });

    setDeletePopup(true);
  };

  return (
    <>
      <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
        <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
          <div className="w-full mt-2">
            <div className={`w-full pb-4`}>
              <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                <div className="flex items-center gap-1.5">
                  <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Edit Season</h2>
                </div>

                {
                  disabled && (
                    <button className={`px-[8px] py-[6px] bg-transparent shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                      onClick={() => setDisabled(false)}
                    >
                      <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textSubHeadingColor}`}>
                        edit
                      </span>
                      <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>Edit</span>
                    </button>
                  )
                }
              </div>

              <div className="mt-2 p-2">
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="w-full px-2">
                    <div className="grid grid-cols-3 gap-6">

                      {/* First Column */}
                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Branch</label>
                          <select
                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={branchId}
                            disabled={disabled}
                            onChange={(e) => setBranchId(e.target.value)}
                          >
                            {branches?.map((role: any, index: number) => (
                              <option key={index} value={role.value}>
                                {role.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Name</label>
                          <input
                            type="text"
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={name}
                            disabled={disabled}
                            onChange={(e) => setName(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-6">
                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Date Start</label>
                          <CustomFormatDatePicker
                            value={dateStart}
                            onChange={setDateStart}
                            dateFormat={dateFormat}
                            disabled={disabled}
                            required={true}
                          />
                        </div>
                      </div>

                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Date End</label>
                          <CustomFormatDatePicker
                            value={dateEnd}
                            onChange={setDateEnd}
                            dateFormat={dateFormat}
                            disabled={disabled}
                            required={true}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-6">
                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Minimal Rental Period (Days)</label>
                          <input
                            type="text"
                            inputMode="numeric"
                            name="minimalRentalPeriodDays"
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={minimalRentalPeriodDays}
                            disabled={disabled}
                            onChange={(e) => {
                              const value = e.target.value.replace(/\D/g, "");
                              setMinimalRentalPeriodDays(value === "" ? 0 : Number(value));
                            }}
                            onKeyDown={(e) => {
                              const allowedKeys = [
                                "Backspace",
                                "Delete",
                                "ArrowLeft",
                                "ArrowRight",
                                "Tab",
                                "Home",
                                "End",
                              ];

                              if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onPaste={(e) => {
                              const pasted = e.clipboardData.getData("text");

                              if (!/^\d+$/.test(pasted)) {
                                e.preventDefault();
                              }
                            }}
                            onDrop={(e) => e.preventDefault()}
                            autoComplete="off"
                            required
                          />
                        </div>
                      </div>

                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                            Max Rental Period (Days)
                          </label>

                          <input
                            type="text"
                            inputMode="numeric"
                            name="maxRentalPeriodDays"
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={maxRentalPeriodDays}
                            disabled={disabled}
                            onChange={(e) => {
                              const value = e.target.value.replace(/\D/g, "");
                              setMaxRentalPeriodDays(value === "" ? 0 : Number(value));
                            }}
                            onKeyDown={(e) => {
                              const allowedKeys = [
                                "Backspace",
                                "Delete",
                                "ArrowLeft",
                                "ArrowRight",
                                "Tab",
                                "Home",
                                "End",
                              ];

                              if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onPaste={(e) => {
                              const pasted = e.clipboardData.getData("text");

                              if (!/^\d+$/.test(pasted)) {
                                e.preventDefault();
                              }
                            }}
                            onDrop={(e) => e.preventDefault()}
                            autoComplete="off"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-6">
                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Minimum Rental Hours</label>
                          <input
                            type="text"
                            inputMode="numeric"
                            name="minimumRentlHours"
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={minimumRentlHours}
                            disabled={disabled}
                            onChange={(e) => {
                              const value = e.target.value.replace(/\D/g, "");
                              setMinimumRentlHours(value === "" ? 0 : Number(value));
                            }}
                            onKeyDown={(e) => {
                              const allowedKeys = [
                                "Backspace",
                                "Delete",
                                "ArrowLeft",
                                "ArrowRight",
                                "Tab",
                                "Home",
                                "End",
                              ];

                              if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onPaste={(e) => {
                              const pasted = e.clipboardData.getData("text");

                              if (!/^\d+$/.test(pasted)) {
                                e.preventDefault();
                              }
                            }}
                            onDrop={(e) => e.preventDefault()}
                            autoComplete="off"
                            required
                          />
                        </div>
                      </div>

                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Maximum Rental Hours</label>
                          <input
                            type="text"
                            inputMode="numeric"
                            name="maximumRentalHours"
                            className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={maximumRentalHours}
                            disabled={disabled}
                            onChange={(e) => {
                              const value = e.target.value.replace(/\D/g, "");
                              setMaximumRentalHours(value === "" ? 0 : Number(value));
                            }}
                            onKeyDown={(e) => {
                              const allowedKeys = [
                                "Backspace",
                                "Delete",
                                "ArrowLeft",
                                "ArrowRight",
                                "Tab",
                                "Home",
                                "End",
                              ];

                              if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onPaste={(e) => {
                              const pasted = e.clipboardData.getData("text");

                              if (!/^\d+$/.test(pasted)) {
                                e.preventDefault();
                              }
                            }}
                            onDrop={(e) => e.preventDefault()}
                            autoComplete="off"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-6">
                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Accounting Account</label>
                          <Select
                            styles={{
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                backgroundColor: themeStyles.topBar.bg,
                                color: themeStyles.topBar.textColor,
                                borderRadius: '8px',
                                borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                                "&: hover": {
                                  borderColor: "#167AC3",
                                }

                              }),
                              menu: (base) => ({
                                ...base,
                                fontSize: "12px",
                                backgroundColor: themeStyles.topBar.bg,
                                color: themeStyles.topBar.textColor,
                              }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected
                                  ? themeStyles.topBar.menuItemsColor
                                  : state.isFocused
                                    ? themeStyles.topBar.menuItemsHoverColor
                                    : "transparent",
                                color: themeStyles.topBar.textColor,
                                fontWeight: 600
                              }),
                              input: (base) => ({
                                ...base,
                                color: themeStyles.topBar.textColor,

                              }),
                              singleValue: (base) => ({
                                ...base,
                                color: themeStyles.topBar.textColor,
                              }),
                            }}
                            className="basic-single"
                            classNamePrefix="select"
                            isDisabled={disabled}
                            isLoading={false}
                            isClearable={true}
                            isRtl={false}
                            isSearchable={false}
                            name="accountingAccount"
                            value={accountingAccountOptions.find(
                              (item: any) => String(item.value) === String(accountingAccount)
                            )}
                            onChange={(accountingAccount: any) =>
                              setAccountingAccount(accountingAccount ? String(accountingAccount.value) : "")
                            }
                            options={accountingAccountOptions}
                          />
                        </div>
                      </div>

                      <div className="mt-4">
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Active?</label>
                        <RadioGroup
                          row
                          value={active}
                          onChange={(e) => setActive(e.target.value)}
                        >
                          <FormControlLabel
                            value="Yes" control=
                            {<Radio
                              disabled={disabled}
                              sx={{
                                color: "gray",
                                "&.Mui-checked": { color: "#167AC3" },
                                "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                              }}
                            />} label="Yes"
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                color: themeStyles.form.labelTextColor,
                              },
                              "&.Mui-disabled .MuiFormControlLabel-label": {
                                color: themeStyles.form.labelTextColor,
                              },
                            }}
                          />
                          <FormControlLabel value="No" control={
                            <Radio
                              disabled={disabled}
                              sx={{
                                color: "gray",
                                "&.Mui-checked": { color: "#167AC3" },
                                "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                              }}
                            />} label="No"
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                color: themeStyles.form.labelTextColor,
                              },
                              "&.Mui-disabled .MuiFormControlLabel-label": {
                                color: themeStyles.form.labelTextColor,
                              },
                            }}
                          />
                        </RadioGroup>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="flex gap-4 mt-6">
                      {
                        !disabled && (
                          <Button variant="contained"
                            sx={{
                              backgroundColor: colorConfigs.btn.main.bg
                            }}
                            type="submit">
                            Save
                          </Button>
                        )
                      }

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.cancel.bg,
                          border: colorConfigs.btn.cancel.border,
                          color: colorConfigs.btn.cancel.color
                        }}
                        onClick={() => navigate(-1)}>
                        Cancel
                      </Button>

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.delete.bg,
                        }}
                        onClick={deleteSeason}>
                        Delete
                      </Button>
                    </div>

                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>
  )
}
